const Breadcrumb = ({ back, current }) => {
  return (
    <nav className="m-2">
      <div className="inline-block font-medium underline">{back}</div>
      <div className="inline-block font-medium">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-6"
          fill="none"
          viewBox="0 0 20 20"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div>
      <div className="inline-block font-medium underline">{current}</div>
    </nav>
  );
};

export default Breadcrumb;
